import React from 'react';
import PropTypes from 'prop-types';
import { PageSEO, useSEO } from '../components/SEO';
import Section01 from '../page-sections/book/Section01';

const Book = ({ location }) => {
  //
  const { pathname } = location;
  const seo = useSEO(pathname);

  return (
    <article>
      <PageSEO title={seo.title} description={seo.description} pathname={pathname} featureImage="og-book.jpg" />
      <Section01 />
    </article>
  );
};

export default Book;

Book.propTypes = {
  location: PropTypes.object.isRequired,
};
